module.exports = __webpack_public_path__ + "front/img/20_m.87d21529.png";